export const PhoneDetails = (props: {phone: string}) => (
  <div className="staff-details__main user">
    <div className="user__icon">
      <img src="../assets/icons/profile.svg" alt="" />
    </div>
    <div>
      <h2 className="user__name">{props.phone}</h2>
    </div>
  </div>
)